
export const Blogs = [
    {
        id:'1',
        img: require('../Image/nunka.jpg'),
        Title:'Núnka',
        Description:'Núnka es una website hippie sobre viajes y experiencias.',
       Link:'/blog/Nunka'
    },
{
    id:'1',
    img:require('../Image/Rioplyas.jpg'),
    Title:'Río Playas',
    Description:'El primer descenso del río playas.' ,
    Link:'/blog/Rioplayas'

},
{
    id:'1',
    img:'https://upload.wikimedia.org/wikipedia/commons/4/4b/Montaje_de_la_Ciudad_de_Buenos_Aires.png',
    Title:'Buenos Aires',
    Description:'Argentina es el destino',
    Link:'https://es.wikipedia.org/wiki/Buenos_Aires'

},
{
    id:'1',
    img:'https://upload.wikimedia.org/wikipedia/commons/thumb/c/c0/Rome_Montage_2017.png/375px-Rome_Montage_2017.png',
    Title:'Roma',
    Description:'La grande italiaaaa',
    Link:'https://es.wikipedia.org/wiki/Roma'

},
{
    id:'1',
    img:'https://es.wikipedia.org/wiki/Archivo:Red_and_white_wine_12-2015.jpg',
    Title:'Vinos',
    Description:'Mini Guia sobre como aprender de vino, elegir, abrir y beberlo'

},


];